import ReactGA4 from 'react-ga4';
import GALogEventsList from './GAEventsList.json';
import axios from 'axios';

/**
 * Standard GA4 event logger
 * @param {Object} params - Event parameters
 * @param {string} params.eventName - Name of the event
 * @param {string} params.category - Event category (required)
 * @param {string} params.action - Event action (required)
 * @param {string} params.label - Event label
 * @param {string} params.sessionId - Session ID
 * @param {string} params.timestamp - Session start timestamp
 * @param {Object} [params.additionalParams] - Any additional parameters to log
 */
export const GALogEvent = ({
    eventId,
    // category,
    // action,
    // label,
    // sessionId,
    // timestamp,
    additionalParams = {}
}) => {

    // Use the eventId to get the eventName, category, action, label, sessionId, and timestamp
    const event = GALogEventsList.find(event => event.id === eventId);
    const { eventName, category, action, label } = event;

    // If we found the event, log it
    if (event) {
        // Direct gtag call instead of ReactGA4
        window.gtag('event', eventName, {
            category,
            action,
            label,
            // user_id: sessionId,
            // sessionStartTime: timestamp,
            ...additionalParams
        });
        // console.log('Logged event:', eventName, category, action, label, additionalParams);

        // Create object for sending to log-get-quoll-events backend
        const logGetQuollEventsObject = {
            eventName,
            category,
            action,
            label,
            ...additionalParams
        };
        // console.log('logGetQuollEventsObject:', logGetQuollEventsObject);

        // Get the base url
        const baseUrl = import.meta.env.VITE_API_BASE_URL;

        // Use axios to send the object to the backend
        axios.post(`${baseUrl}/log-get-quoll-events`, logGetQuollEventsObject)
            .then(response => {
                return null;
            })
            .catch(error => {
                // console.error('Error sending event to log-get-quoll-events:', error);
            });
    } else {
        // console.error(`Event ${eventId} not found in GALogEventsList`);
    }

    // ReactGA4.event({
    //     event_name: eventName,
    //     category,
    //     action,
    //     label,
    //     user_id: sessionId,
    //     sessionStartTime: timestamp,
    //     ...additionalParams
    // });

    // ReactGA4.event({
    //     event_name: eventName,
    //     category,
    //     action,
    //     label,
    //     user_id: sessionId,
    //     sessionStartTime: timestamp,
    //     ...additionalParams
    // });
};
